import { Component, ViewChild } from '@angular/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { OverlayPanel } from 'primeng/overlaypanel';
import { CommonModule } from '@angular/common';
import { EventBusService } from '../../event-bus.service';
import { PermissionService } from '../../permissions.service';
import { signOut } from 'aws-amplify/auth';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  standalone: true,
  imports: [
    ButtonModule,
    OverlayPanelModule,
    CommonModule
  ]
})
export class UserMenuComponent {
  @ViewChild('userMenuPanel') userMenuPanel!: OverlayPanel;
  isOpen = false;

  constructor(private router: Router, private eventBusService: EventBusService, private permissionService: PermissionService) {}

  navigateToAccountSettings() {
    this.router.navigate(['/account-settings']);
  }

  toggleOverlay(event: Event): void {
    this.isOpen = !this.isOpen;
    this.userMenuPanel.toggle(event);
  }

  async onLogout() {
    await signOut();
    this.eventBusService.publish('user:logout');
    this.permissionService.reloadRolesAndPermissions();
    this.router.navigate(['/login']);
  }
}
